// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"aaf7f8cd-168":"c2460786a530d83fd1ad","aaf7f8cd-452":"1a6ab0b90d408dce75e4","aaf7f8cd-379":"d259e0164e5c87ce4679","aaf7f8cd-83":"98baf92fe40613fd3948"}[chunkId] + ".js";
};